import { SET_MY_CARS_ENABLED, SET_MY_CARS_SAVED } from '../actions/types';

export default function myCars(
	state = {
		enabled: false,
		savedVehicles: null
	},
	action
) {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_MY_CARS_SAVED:
				return {
					...state,
					savedVehicles: action.payload
				};
			case SET_MY_CARS_ENABLED:
				return {
					...state,
					enabled: action.payload
				};

			// no default
		}
	}

	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/myCars.js